import type { AppAbility } from '@/lib/casl'
import { notFound } from '@tanstack/react-router'

interface SeasonalContentAccessOptions {
  context: { ability: Pick<AppAbility, 'can'> }
  /** Also require permission to change global content. */
  requireEdit?: boolean
}

export function requireGlobalSeasonalContentAccess({
  context,
  requireEdit = false,
}: SeasonalContentAccessOptions): { isReadOnly: boolean } {
  const canView = context.ability.can('list', 'designs')
  const canEdit = context.ability.can('manage', 'global-content')

  if (!canView || !context.ability.can('access', 'global') || (requireEdit && !canEdit)) {
    throw notFound()
  }

  return { isReadOnly: !canEdit }
}
